/**
 * Created by jomsm on 26/07/2017.
 */
(function () {

    'use strict';

    angular.module('Services').factory('FuelLeviesTableService', FuelLeviesTableService);

    FuelLeviesTableService.$inject = [
        'Carrier', 
        'TableLiteFactory', 
        '$location', 
        '$uibModal', 
        'toastr', 
        'ConfirmationModalFactory',
        'Currency',
        '$filter',
        '$rootScope',
    ];

    function FuelLeviesTableService(
        Carrier, 
        TableLiteFactory, 
        $location, 
        $uibModal, 
        toastr, 
        ConfirmationModalFactory, 
        Currency,
        $filter,
        $rootScope
    ) {
        return function (serviceDetailsList) {
            let allServices = angular.copy(serviceDetailsList.services);
            let currencies = [];
            serviceDetailsList.carriers.unshift({
                name: 'All carriers',
                id: null,
                services: []
            });
            let tableStructure = {
                tableName: 'fuelLeviesTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'CREATE NEW FUEL LEVY',
                        tooltip: 'Click to create new Fuel Levy',
                        onClick: function () {
                            initFuelLevy();
                        }
                    }],
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noTopOptions: false,
                    noFooter: false,
                    rowsUnclickable: false
                },
                headers: [
                    {
                        label: 'PROFILE NAME',
                        viewName: 'profileName',
                        filterName: 'name',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header))
                            },
                            model: ''
                        },
                        headerFn: sort
                    }, {
                        label: 'CARRIER',
                        viewName: 'carrierName',
                        filterName: 'carrierId',
                        filter: {
                            type: 'select2',
                            placeholder: 'Search',
                            class: 'filter-carrier-name',
                            viewName: 'name',
                            filterBy: 'id',
                            items: serviceDetailsList.carriers, //List of items shown in dropdown
                            onSubmit: function (header) {
                                delete tableActions.activeFilters.serviceId;
                                if (serviceDetailsList.serviceHeader)
                                    delete serviceDetailsList.serviceHeader.filter.model;
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                                if(header.filter.model.id === null){
                                    serviceDetailsList.services = allServices;
                                }else{
                                    serviceDetailsList.services.length = 0;
                                    angular.forEach(header.filter.model.services, function (serv) {
                                        serviceDetailsList.services.push(serv);
                                    });
                                }
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    }, {
                        label: 'SERVICE',
                        viewName: 'serviceName',
                        filterName: 'serviceId',
                        filter: {
                            type: 'select2',
                            placeholder: 'Search',
                            class: 'filter-service-type',
                            viewName: 'name',
                            filterBy: 'id',
                            items: serviceDetailsList.services,
                            onSubmit: function (header) {
                                serviceDetailsList.serviceHeader = header;
                                tableActions.sendRequest(angular.extend(tableActions.evaluateFilter(header), {carrierId: header.filter.model.carrierId}));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    }, {
                        label: 'Fixed Fuel Levy',
                        viewName: 'fixedFuelLevy',
                        filterName: 'fixedFuelLevy',
                        /*filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header))
                            },
                            model: ''
                        },*/
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    }, {
                        label: 'Percentage Fuel Levy',
                        viewName: 'percentageFuelLevy',
                        filterName: 'percentageFuelLevy',
                        /*filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                sendRequest(evaluateFilter(header))
                            },
                            model: ''
                        },*/
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    }, {
                        label: 'STATUS',
                        viewName: 'enabled',
                        filterName: 'active',
                        filter: {
                            type: 'select2',
                            placeholder: 'Select One',
                            items: ['Enabled', 'Disabled'],
                            onSelect: function(header) {
                                let filter = {};

                                filter[header.filterName] = header.filter.model === 'Enabled';

                                sendRequest(filter);
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    }],
                data: [],
                onInit: ()=>{
                    Currency.getList((data) => {
                        currencies = data;
                        sendRequest({});
                    }, (error) => {
                        toastr.error('Unable to get currencies', error.message);
                    });
                },
                rowOnClick: initFuelLevy,
                resetFilters: resetFilters
            };
            const tableActions = new TableLiteFactory(tableStructure,
                {
                    serviceCallback: Carrier.getFuelLevies,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 20,
                        page: 0,
                        sort: 'country,asc'
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;
            
            showSelectedFuelLevyFromUrl();
            function showSelectedFuelLevyFromUrl() {
                const profileName = $location.search()['profile-name'];
                Carrier.getFuelLevies(success => {
                    if (success.content.length > 0) {
                        initFuelLevy(success.content[0]);
                    }
                }, error => {
                    toastr.error(error.message, 'Error');
                }, {
                    name: profileName
                });
            }

            function resetFilters() {
                angular.forEach(tableStructure.headers, function (header) {
                    if (header.filter) {
                        if (header.filter.model)
                            header.filter.model = '';
                        if (header.filter.toModel)
                            header.filter.toModel = '';
                        if (header.filter.fromModel)
                            header.filter.fromModel = '';
                        delete tableActions.activeFilters[header.filterName];
                    }
                });
                serviceDetailsList.services.length = 0;
                angular.forEach(allServices, function (service) {
                    serviceDetailsList.services.push(service);
                });
                tableActions.sendRequest({});
            }

            function initFuelLevy(levy) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'setting-modal',
                    templateUrl: '/templates/pages/carriers/fuel-levies-edit.html',
                    controller: 'FuelLeviesController',
                    controllerAs: 'vm',
                    size: 'lg',
                    appendTo: $('body'),
                    resolve: {
                        levy: () => {
                            return levy;
                        },
                        currencies: () => {
                            return currencies;
                        },
                        serviceDetailsList: () => {
                            return serviceDetailsList;
                        }
                    }
                });
                modalInstance.result.then(function (data) {
                    sendRequest({});
                }, function () {
                });
            }

            function buildTableData(data, pagination) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);

                angular.forEach(data.content, function (row, index) {
                    row.profileName = row.name || 'N/A';
                    row.carrierName = {
                        type: 'logotype',
                        imgSrc: angular.getObjVal(row, 'logoUrl') ? angular.getObjVal(row, 'logoUrl') :
                            'http://via.placeholder.com/300x100?text=ALL+CARRIERS'
                    };
                    row.fixedFuelLevy = row.fixed ? $filter('bbaCurrency')(row.fixed, '') : 'N/A';
                    row.percentageFuelLevy = row.percentage ? row.percentage + ' %' : 'N/A';
                    row.serviceName = angular.getObjVal(row, 'service.serviceName') ?
                        angular.getObjVal(row, 'service.serviceName') : 'All services';
                    row.enabled = {
                        type: 'status',
                        status: row.active,
                        label: row.active ? 'Enabled' : 'Disabled'
                    };
                    tableStructure.data.push(row);
                });
                /*** END - Building of Data ***/
            }
            this.tableData = tableStructure;
        }
    };
})();



// WEBPACK FOOTER //
// ./js/services/tables/FuelLeviesTableService.js